import { SortOption } from '../../../ui/components/baseTable/dtos/SortOption.dto'
import { TableColumn } from '../../../ui/components/baseTable/dtos/TableColumn.dto'
import FireOutbreakCardReactionMenu from '../components/FireOutbreakCardReactionMenu.vue'
import { SortDirection } from '../../../ui/components/baseTable/enums/SortDirection.enum'

export class FireAlertsTableHeadersFactory {
	static make(sortOptions: SortOption[]): TableColumn[] {
		const headers = [
			{
				name: 'Detecção',
				key: 'detectedAtLabel',
				enableSort: true,
				sortKey: 'detectedAt',
				sortActive: sortOptions.find((sort) => sort.key === 'detectedAt')
					?.direction as SortDirection,
			},
			{
				name: 'Comunicação',
				key: 'statedAtLabel',
				enableSort: true,
				sortKey: 'statedAt',
				sortActive: sortOptions.find((sort) => sort.key === 'statedAt')?.direction,
			},
			{
				name: 'Fazenda',
				key: 'farm',
				enableSort: true,
				sortActive: sortOptions.find((sort) => sort.key === 'farm')?.direction,
			},
			{
				name: 'Risco Climático',
				key: 'riskLabel',
				enableSort: true,
				sortActive: sortOptions.find((sort) => sort.key === 'riskLabel')?.direction,
			},
			{
				name: 'Satélite',
				key: 'satellite',
				enableSort: true,
				sortActive: sortOptions.find((sort) => sort.key === 'satellite')?.direction,
			},
			{
				name: 'Radiância',
				key: 'radianceLabel',
				enableSort: true,
				sortKey: 'radiance',
				sortActive: sortOptions.find((sort) => sort.key === 'radiance')?.direction,
			},
			{
				name: 'Confiança',
				key: 'detectionConfidenceLabel',
				enableSort: true,
				sortKey: 'detectionConfidence',
				sortActive: sortOptions.find((sort) => sort.key === 'detectionConfidence')?.direction,
			},
			{
				name: 'Local',
				key: 'occurrenceLabel',
				enableSort: true,
				sortKey: 'occurrence',
				sortActive: sortOptions.find((sort) => sort.key === 'occurrence')?.direction,
			},
			{
				name: 'Avaliação',
				key: 'reaction',
				component: FireOutbreakCardReactionMenu,
			},
		]

		return [...headers]
	}
}
